'use strict'
var Marionette = require('marionette')
var App = require('app')
var Moment = require('moment')
var _ = require('lodash')
//
var rhmRegisters = require('src/common/app-constants-rhm').rhmRegister

module.exports = {
  getLastSeenAt: function () {
    if (this.lastSeenAt) {
      return this.lastSeenAt
    }
  },
  //
  getHideClasses: function(options) {
    return function(key) {
      let classes = "";
      let hideSizes = _.get(options, 'columns.'+key+'.hideSizes')

      if (key === "_bulk") {
        classes += "hide-size-mobile ";
        return classes
      }
      if (!hideSizes || hideSizes.length === 0) return classes;

      hideSizes.forEach(function(size) {
        classes += "hide-size-"+size+" ";
      }, this);

      return classes;
    }
  },
  getAttribute: function (path, defaultValue) {
    var value = _.get(this, path)
    if (!value) value = defaultValue
    return value
  },
  formatTime: function (time, format) {
    if (!time) return
    if (!format) format = 'DD MMM YYYY, HH:mm'
    var localDate = Moment(time).local()

    return localDate.format(format)
  },
  formatTimeFromNow: function (time) {
    if (!time) return 'never'
    return Moment(time).fromNow()
  },
  getConditionalStr: function (condition, truthyStr, falsyStr) {
    if (condition) {
      return truthyStr
    }

    return falsyStr
  },
  hasSensor: function (sensor) {
    if (!this.sensors) return false
    if (!this.sensors[sensor]) return false
    return true
  },
  getSensorValue: function (sensor) {
    if (!this.sensors) return false
    if (!this.sensors[sensor]) return false

    return this.sensors[sensor].value
  // console.log(this.sensors[sensor].value)
  // switch (sensor) {
  //   case 'pri_voltage':
  //     return this.sensors[sensor].value
  //     // if (!this.sensors[sensor].value) return
  //     // return this.sensors[sensor].value
  //     break
  // }
  },
  hasProperty: function (property) {
    if (!this.properties) return false
    if (!this.properties[property]) return false
    return true
  },
  getPropertyValue: function (property, attribute) {
    if (!this.properties) return false
    if (!this.properties[property]) return false
    if (attribute) {
      return this.properties[property]['attributes'][attribute]

    } else {
      return this.properties[property].value

    }
  // console.log(this.sensors[sensor].value)
  // switch (sensor) {
  //   case 'pri_voltage':
  //     return this.sensors[sensor].value
  //     // if (!this.sensors[sensor].value) return
  //     // return this.sensors[sensor].value
  //     break
  // }
  },
  getClientName: function (id) {
    var clients = App.TemplateHelpers.getClients()
    return clients[id]
  },
  getClients: function () {
    var clients = App.globalChannel.request('client:entities:cached')
    var clientList = {}
    clients.each(function (model) {
      clientList[model.get('_id')] = model.get('name')
    })
    return clientList
  },
  getSensorFieldName: function (sensor, attribute) {
    return 'sensors[' + sensor + '][attributes][' + attribute + ']'
  },
  getPropertyFieldName: function (property, attribute) {
    return 'properties[' + property + '][attributes][' + attribute + ']'
  },
  getSensorAttribute: function (sensor, attribute, defaultValue) {
    if (!this.sensors) return defaultValue
    if (!this.sensors[sensor]) return defaultValue
    return this.sensors[sensor].attributes[attribute]
  },
  getPropertyAttribute: function (property, attribute) {
    if (!this.properties) return 0
    if (!this.properties[property]) return 0
    return this.properties[property].attributes[attribute]
  },
  //
  getDeviceTypes: function () {
    var deviceTypes = App.entities.enums.get('deviceTypes')
    return deviceTypes
  },
  getDeviceTypeLabel: function (value) {
    var deviceTypes = App.entities.enums.get('deviceTypes')
    var type = this.type
    if (value) type = value
    if (type) {
      if (!deviceTypes[type]) return 'Unknown devicetype'
      return deviceTypes[type].name
    }
  },
  getRhmRegisters: function () {
    return rhmRegisters
  },
  userHasRole: function (role) {
    return App.session.user.hasRole(role)
  },
  getApiRoles: function () {
    return {
      admin:{name:'admin'},
      super:{name:'super'}
    }
  },
  getUserRoles: function () {
    var userRoles = App.entities.enums.get('userRoles')
    // return userRoles
    switch (App.session.user.get('role')) {
      case 'super':
        break
      case 'admin':
        userRoles = _.omit(userRoles, ['super'])
        break
      case 'client':
        break
      case 'user':
        break
      default:

        break
    }
    return userRoles
  },
  getUserRoleLabel: function (value) {
    var role = false
    if (value) {
      role = value
    } else {
      role = this.role
    }

    var userRoles = App.entities.enums.get('userRoles')
    if (role) {
      return userRoles[role].name
    } else {
      return '-'
    }
  }
}

// var Marionette = require('marionette'),
//     Backbone = require('backbone'),
//     App = require('app'),
//     _ = require('lodash'),
//     Config = require('config'),
//     Helpers

// /**
//  *
//  * The router for our presentation module,
//  * a good rule of thumb is to have one router per module
//  */
// Helpers = {

//     /* permissions */
//     userIsAdmin: function() {

//         if (App.entities.usersession.get('role') === 'admin') {
//             return true
//         }
//         return false
//     },
//     userIsClient: function() {

//         if (App.entities.usersession.get('role') === 'client') {
//             return true
//         }
//         return false
//     },
//     userIsExpert: function() {

//         if (App.entities.usersession.get('role') === 'expert') {
//             return true
//         }
//         return false
//     },

//     config: Config,

//     getQueueName: function( id ) {
//         return App.entities.queues.get( id ).get('name')
//     },

//     getExpertName: function( id ) {

//         var user = App.entities.users.get( id )

//         var name = '--'

//         if (user) {
//             name = user.get('name')
//         }
//         return name
//         //return App.entities.users.get( id ).get('name')
//     },

//     queueName: function() {
//         var kiosk = App.entities.kiosks.get( this.kiosk )
//         return App.entities.queues.get( kiosk.get('queue')._id ).get('name')
//     },
//     kioskName: function() {
//         var kiosk = App.entities.kiosks.get( this.kiosk )
//         return kiosk.get('physicalKiosk').name + ' [ '+kiosk.get('name')+' ] '
//     },
// }

// module.exports = Helpers



// WEBPACK FOOTER //
// ./js/common/template-helpers.js